(() => {
  if (window.__c_page_toggle_initialized) return;
  window.__c_page_toggle_initialized = true;

  function bindToggle(trigger, { collapsedClass } = {}) {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isExpanded));
      if (collapsedClass) {
        panel.classList.toggle(collapsedClass, isExpanded);
      } else {
        panel.hidden = isExpanded;
      }
    });
  }

  function initAccordion(section) {
    section.querySelectorAll('.c_page-accordion__trigger').forEach((trigger) => {
      bindToggle(trigger);
    });
  }

  function initSteps(section) {
    section.querySelectorAll('.c_page-steps__toggle').forEach((trigger) => {
      bindToggle(trigger, { collapsedClass: 'c_page-steps__panel--collapsed' });
    });
  }

  const FAQ_ANIMATION_OPTIONS = { duration: 380, easing: 'ease-out' };

  const animateFaqPanel = (trigger, panel, isOpening) => {
    if (panel._faqAnimation) {
      panel._faqAnimation.cancel();
    }

    if (isOpening) {
      panel.hidden = false;
    }

    const fromHeight = isOpening ? 0 : panel.offsetHeight;
    const toHeight = isOpening ? panel.scrollHeight : 0;

    panel.style.height = `${fromHeight}px`;
    panel.style.opacity = isOpening ? '0' : '1';
    panel.style.overflow = 'hidden';
    panel.dataset.animStatus = 'running';
    trigger.setAttribute('aria-expanded', String(isOpening));

    const animation = panel.animate(
      [
        { height: `${fromHeight}px`, opacity: isOpening ? 0 : 1 },
        { height: `${toHeight}px`, opacity: isOpening ? 1 : 0 },
      ],
      FAQ_ANIMATION_OPTIONS,
    );
    panel._faqAnimation = animation;

    const cleanup = () => {
      panel.style.height = '';
      panel.style.opacity = '';
      panel.style.overflow = '';
      panel.dataset.animStatus = '';
      panel._faqAnimation = null;
    };

    animation.onfinish = () => {
      cleanup();
      panel.hidden = !isOpening;
    };
    animation.oncancel = cleanup;
  };

  const bindFaqToggle = (trigger) => {
    const panelId = trigger.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    trigger.addEventListener('click', () => {
      if (panel.dataset.animStatus === 'running') return;
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      animateFaqPanel(trigger, panel, !isExpanded);
    });
  };

  function initFaq(section) {
    section.querySelectorAll('.c_page-faq__group-trigger').forEach(bindFaqToggle);
    section.querySelectorAll('.c_page-faq__trigger').forEach(bindFaqToggle);
  }

  const faqSidebarState = new WeakMap();

  const initFaqSidebar = (sidebar) => {
    const previous = faqSidebarState.get(sidebar);
    if (previous) {
      if (previous.cleanupNavigation) previous.cleanupNavigation();
      if (previous.resizeObserver) previous.resizeObserver.disconnect();
      if (previous.onResize) window.removeEventListener('resize', previous.onResize);
      if (previous.onLoad) window.removeEventListener('load', previous.onLoad);
    }

    const faqSections = Array.from(document.querySelectorAll('.c_page-faq'));
    if (faqSections.length === 0) {
      sidebar.style.display = 'none';
      return;
    }
    sidebar.style.display = '';

    const findShopifySectionWrapper = (el) => {
      const sectionId = el.dataset.sectionId;
      if (sectionId) {
        const byId = document.getElementById(`shopify-section-${sectionId}`);
        if (byId) return byId;
      }
      return el.closest('.shopify-section') || el.closest('[id^="shopify-section-"]') || el;
    };

    const OVERLAP_BUFFER = 16;

    const checkOverlap = () => {
      const faqBoxEl = findShopifySectionWrapper(faqSections[0]);
      // display:none の状態だと rect が 0 になるため一度解除して強制リフローしてから計測
      sidebar.dataset.overlap = 'false';
      void sidebar.offsetWidth;

      const listEl = sidebar.querySelector('.c_page-faq-sidebar__list');
      const listRect = listEl ? listEl.getBoundingClientRect() : null;
      const sidebarRect = sidebar.getBoundingClientRect();
      const referenceRight = listRect && listRect.width > 0 ? listRect.right : sidebarRect.right;
      const referenceWidth = listRect && listRect.width > 0 ? listRect.width : sidebarRect.width;

      const faqBoxRect = faqBoxEl.getBoundingClientRect();
      const isOverlap = referenceWidth > 0 && referenceRight + OVERLAP_BUFFER > faqBoxRect.left;
      sidebar.dataset.overlap = String(isOverlap);
    };

    const updatePosition = () => {
      const firstWrapper = findShopifySectionWrapper(faqSections[0]);
      const lastWrapper = findShopifySectionWrapper(faqSections[faqSections.length - 1]);

      const firstRect = firstWrapper.getBoundingClientRect();
      const lastRect = lastWrapper.getBoundingClientRect();
      const top = firstRect.top + window.scrollY;
      const bottom = lastRect.bottom + window.scrollY;
      sidebar.style.setProperty('--c-faq-sidebar-anchor-top', `${top}px`);
      sidebar.style.setProperty('--c-faq-sidebar-height', `${Math.max(0, bottom - top)}px`);

      sidebar.dataset.ready = 'true';
      checkOverlap();
    };

    updatePosition();

    let resizeTimer;
    const onResize = () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updatePosition, 100);
    };
    window.addEventListener('resize', onResize);

    const onLoad = () => updatePosition();
    window.addEventListener('load', onLoad);

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => updatePosition());
      faqSections.forEach((section) => resizeObserver.observe(section));
    }

    const items = Array.from(sidebar.querySelectorAll('[data-target-anchor]'));
    const targets = [];
    items.forEach((item) => {
      const anchorId = item.dataset.targetAnchor;
      if (!anchorId) return;
      const anchorEl = document.getElementById(anchorId);
      if (!anchorEl) return;
      const faqSection = anchorEl.closest('.c_page-faq') || anchorEl;
      targets.push({ item, faqSection });
    });

    // 見出しの位置を基準にする。画面中央の交差判定だと、次のカテゴリが選択されてしまう。
    const getOffset = () => {
      const styles = getComputedStyle(document.documentElement);
      const headerHeight = parseFloat(styles.getPropertyValue('--header-height')) || 0;
      const announcementHeight = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
      const stickyHeader = Number(styles.getPropertyValue('--enable-sticky-header')) || 0;
      const stickyAnnouncement = Number(styles.getPropertyValue('--enable-sticky-announcement-bar')) || 0;
      return headerHeight * stickyHeader + announcementHeight * stickyAnnouncement + 40;
    };
    const headingTop = (target) =>
      (target.faqSection.querySelector('.c_page-faq__group-trigger') || target.faqSection).getBoundingClientRect().top;
    const setActive = (target) => targets.forEach((entry) => {
      entry.item.classList.toggle('is-active', entry === target);
      const link = entry.item.querySelector('a');
      if (!link) return;
      if (entry === target) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    const updateActive = () => {
      let active = targets[0];
      targets.forEach((target) => {
        if (headingTop(target) <= getOffset() + 2) active = target;
      });
      setActive(active);
    };
    const navigate = (target) => {
      window.scrollTo({ top: Math.max(0, window.scrollY + headingTop(target) - getOffset()), behavior: 'instant' });
      setActive(target);
    };
    const clickHandlers = targets.map((target) => {
      const link = target.item.querySelector('a');
      const onClick = (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
        navigate(target);
      };
      if (link) link.addEventListener('click', onClick);
      return { link, onClick };
    });
    const onHashChange = () => {
      const target = targets.find((entry) => entry.item.querySelector('a')?.hash === window.location.hash);
      if (target) navigate(target);
    };
    let scrollFrame;
    const onScroll = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = null;
        updateActive();
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('hashchange', onHashChange);
    const onNavigationLoad = () => { onHashChange(); updateActive(); };
    window.addEventListener('load', onNavigationLoad);
    updateActive();
    const cleanupNavigation = () => {
      clickHandlers.forEach(({ link, onClick }) => link?.removeEventListener('click', onClick));
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('hashchange', onHashChange);
      window.removeEventListener('load', onNavigationLoad);
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
    };
    faqSidebarState.set(sidebar, { cleanupNavigation, resizeObserver, onResize, onLoad });
  };

  const init = () => {
    document.querySelectorAll('.c_page-accordion').forEach(initAccordion);
    document.querySelectorAll('.c_page-steps').forEach(initSteps);
    document.querySelectorAll('.c_page-faq').forEach(initFaq);
    document.querySelectorAll('.c_page-faq-sidebar').forEach(initFaqSidebar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify && Shopify.designMode) {
    const reinitFaqSidebars = () => {
      document.querySelectorAll('.c_page-faq-sidebar').forEach(initFaqSidebar);
    };
    document.addEventListener('shopify:section:load', (e) => {
      e.target.querySelectorAll('.c_page-accordion').forEach(initAccordion);
      e.target.querySelectorAll('.c_page-steps').forEach(initSteps);
      e.target.querySelectorAll('.c_page-faq').forEach(initFaq);
      reinitFaqSidebars();
    });
    document.addEventListener('shopify:section:unload', reinitFaqSidebars);
  }
})();
